import { useSelector } from 'react-redux';
import { useApiMutation } from '../../../../../infra/api';
import { endpoints } from '../../../network/endpoints';
import { getTemporaryTwoFaUserToken } from '../store';
export var useTwoFaCheckHandlers = function () {
    var token = useSelector(getTemporaryTwoFaUserToken);
    var _a = useApiMutation({
        endpoint: endpoints.twoFaChallenge,
    }), twoFaChallengeMutation = _a.mutateAsync, resetTwoFaChallenge = _a.reset;
    var _b = useApiMutation({
        endpoint: endpoints.twoFaValidate,
    }), twoFaValidateMutation = _b.mutateAsync, resetTwoFaValidate = _b.reset;
    var reset = function () {
        resetTwoFaChallenge();
        resetTwoFaValidate();
    };
    var sendVerificationCode = function (verificationType) {
        return twoFaChallengeMutation({
            type: verificationType === 'phone' ? 'sms' : 'email',
            token: token,
        });
    };
    var validateCode = function (verificationType, code) {
        return twoFaValidateMutation({
            type: verificationType === 'phone' ? 'sms' : 'email',
            code: code,
            token: token,
        });
    };
    return {
        sendVerificationCode: sendVerificationCode,
        validateCode: validateCode,
        reset: reset,
    };
};
